<template>
    <div>
        <UiCardListHeader :title="props.settings.title" />

        <UiCard class="p-3 text-xs [&_a]:underline [&_a:hover]:no-underline">
            <!-- eslint-disable-next-line -->
            <div v-html="props.settings.content"></div>
        </UiCard>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    settings: {
        type: Object,
        required: true,
    },
});
</script>
